import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import {
  getUrlParams,
  setUrlParams,
} from "../../../utils/helpers/setAndGetUrlParams";
import { useSearchParams } from "react-router-dom";

const PaginationControls = ({
  totalPages = 1,
  onPageChange,
  onLimitChange,
  currentPageDataCount,
  isFetching = false,
  totalCount = 5,
  moduleName,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = getUrlParams("page")
    ? Number(getUrlParams("page")) - 1
    : 0;
  const initialLimit = getUrlParams("limit")
    ? Number(getUrlParams("limit"))
    : 50;

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);

  useEffect(() => {
    setCurrentPage(initialPage);
  }, [initialPage]);

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(event.selected);
    onPageChange(selectedPage);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    onLimitChange(newLimit);
    setUrlParams(setSearchParams, "limit", newLimit);
    setUrlParams(setSearchParams, "page", 1);
  };

  return (
    <div className="pagination-controls mb-2 d-flex flex-column flex-md-row justify-content-between align-items-center">
      <div className="text-dark mb-2 mb-md-0">
        Showing <span className="fw-bold">{currentPageDataCount}</span> of{" "}
        <span className="fw-bold">{totalCount}</span> {moduleName} for page{" "}
        <strong>{currentPage + 1}</strong>
      </div>

      <div className="d-flex align-items-center gap-3">
        {/* Limit Selector Dropdown */}
        <select
          className="form-select form-select-sm py-0"
          value={limit}
          onChange={handleLimitChange}
          style={{ height: "30px" }}
        >
          {[25, 50, 100].map((value) => (
            <option key={value} value={value}>
              {value} Records Per Page
            </option>
          ))}
        </select>

        {/* Pagination Controls */}
        <ReactPaginate
          previousLabel={<FaArrowLeft size={15} />}
          nextLabel={<FaArrowRight size={15} />}
          pageCount={totalPages}
          forcePage={currentPage}
          onPageChange={handlePageClick}
          containerClassName={"pagination d-flex align-items-center gap-2"}
          activeClassName={"active"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link small-btn"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link small-btn"}
          disabledClassName={"disabled"}
          pageRangeDisplayed={2} // Shows only 1 page number before & after the current page
          marginPagesDisplayed={2} // Always shows the first 2 and last 2 pages in pagination
        />
      </div>
    </div>
  );
};

export default PaginationControls;
